import React from "react";
import { Input } from "../../../components/Input";
import Divider from "@mui/material/Divider";
// import classes from "./formStep2.module.scss";
import { useTranslation } from "react-i18next";
import Checkbox from "../../../components/Chechbox";
import ButtonComponent from "../../../components/ButtonComponent";
import { COLORS } from "../../../lib/colors";

function FormStep2({
  handleChange,
  history_disease_1,
  history_disease_2,
  history_disease_3,
  history_disease_4,
  history_disease_5,
  history_disease_6,
  history_disease_7,
  history_disease_8,
  history_disease_9,
  history_disease_10,
  history_disease_11,
  history_disease_12,
  history_disease_13,
  medicalnote,
  handleSubmit,
  loading,
}) {
  const { t } = useTranslation();

  return (
    <div>
      <div>{t("pages.protectedPages.medicalHistory.organs.title")}</div>
      <div>
        <Checkbox
          name="history_disease_1"
          checked={history_disease_1}
          handleChange={handleChange}
          labelText=""
          value={history_disease_1}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.1")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_2"
          checked={history_disease_2}
          handleChange={handleChange}
          labelText=""
          value={history_disease_2}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.2")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_3"
          checked={history_disease_3}
          handleChange={handleChange}
          labelText=""
          value={history_disease_3}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.3")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_4"
          checked={history_disease_4}
          handleChange={handleChange}
          labelText=""
          value={history_disease_4}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.4")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_5"
          checked={history_disease_5}
          handleChange={handleChange}
          labelText=""
          value={history_disease_5}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.5")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_6"
          checked={history_disease_6}
          handleChange={handleChange}
          labelText=""
          value={history_disease_6}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.6")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_7"
          checked={history_disease_7}
          handleChange={handleChange}
          labelText=""
          value={history_disease_7}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.7")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_8"
          checked={history_disease_8}
          handleChange={handleChange}
          labelText=""
          value={history_disease_8}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.8")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_9"
          checked={history_disease_9}
          handleChange={handleChange}
          labelText=""
          value={history_disease_9}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.9")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_10"
          checked={history_disease_10}
          handleChange={handleChange}
          labelText=""
          value={history_disease_10}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.10")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_11"
          checked={history_disease_11}
          handleChange={handleChange}
          labelText=""
          value={history_disease_11}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.11")}</label>
      </div>
      <div>
        <Checkbox
          name="history_disease_12"
          checked={history_disease_12}
          handleChange={handleChange}
          labelText=""
          value={history_disease_12}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.12")}</label>
      </div>
      <Divider />

      <div>{t("pages.protectedPages.medicalHistory.organs.inputTitle")}</div>

      <Input
        name="medicalnote"
        onChange={handleChange}
        required
        value={medicalnote}
        label={t("pages.protectedPages.medicalHistory.organs.input")}
      />

      {/* <h4>{t("pages.protectedPages.medicalHistory.organs.footer")}</h4> */}

      <div>
        <Checkbox
          name="history_disease_13"
          checked={history_disease_13}
          handleChange={handleChange}
          labelText=""
          value={history_disease_13}
        />
        <label>{t("pages.protectedPages.medicalHistory.organs.accept")}</label>
      </div>

      <div style={{ textAlign: "center" }}>
        <ButtonComponent
          backgroundColor={COLORS.purple}
          onClick={handleSubmit}
          width={200}
          loading={loading}
          disabled={loading}
        >
          {t("pages.protectedPages.medicalHistory.organs.save")}
        </ButtonComponent>
      </div>
    </div>
  );
}

export default FormStep2;
